import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbFullPageFlow as ClbFullPageFlow_ } from '@celebration/design-system/dist/lib/full-page-flow';
const events = {
    onClbClose: ClbFullPageFlow_.events.onClbClose,
    onClbHaveOpened: ClbFullPageFlow_.events
        .onClbClose,
    onClbHaveClosed: ClbFullPageFlow_.events
        .onClbClose,
};
export const ClbFullPageFlow = createComponent({
    tagName: ClbFullPageFlow_.tagName,
    elementClass: ClbFullPageFlow_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map